import {
  DefaultButton,
  Icon,
  IconButton,
  Modal,
  PrimaryButton,
} from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import ModalHeader from "../../../components/Modal/ModalHeader";
import ModalFooter from "../../../components/Modal/ModalFooter";
import loaderContext from "../../../context/loader/LoaderContext";
import ModalMain from "../../../components/Modal/ModalMain";
import themeContext from "../../../context/theme/ThemeContext";
import { darkTheme } from "../../../constants/Themes";
import Tour from "reactour";
import userContext from "../../../context/users/UserContext";
import { MODAL_TYPE, USERTYPES } from "../../../constants/Constants";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import ImageCount from "../../../components/SVGComponents/ImageCount";
import UploadHistoryIcon from "../../../components/SVGComponents/StudyList/Actions/UploadHistoryIcon";
import { updateUserSettings } from "../../../service/UserService";

const TourGuide = (props) => {
  const {
    showModal,
    setShowModal,
    enableButtonTourPurpose,
    setEnableButtonTourPurpose,
  } = useContext(loaderContext);
  const { loadByUsername,authenticated, roles, userSettings,userId, setUserSettings } = useContext(userContext);
  const { theme, themeName, setThemeName, setTheme, getThemeColor } = useContext(themeContext);
  const {setLoaderRunning, ref} = useContext(loaderContext);
  const [desiredStep, setDesiredStep] = useState(0);
  const [showTour, setShowTour] = useState(false);

  const handleCloseModal = () => {
    console.log("--- userSetting ---",userSettings);
    
    if (
      (userSettings == null || userSettings == undefined || userSettings?.theme == null  ||userSettings?.studylistTour === false)
     ) {
       changeTourUpdate(userSettings?.theme, true, userSettings?.viewerTour,false);
     }else{
      setShowModal({ show: false });
     }
     
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const changeTourUpdate = async(themeValue,studyListTour,viewerTour,showThemePreference) => {
    let body = {
      userSettings:{
        "theme":themeValue != null && themeValue != undefined ? themeValue : "dark-midnight",
        "studylistTour":studyListTour,
        "viewerTour":viewerTour != null && viewerTour != undefined ? viewerTour : false,
        "showThemePreference": showThemePreference != null && showThemePreference != undefined ? showThemePreference : false,
      }
    }
    try{
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await updateUserSettings(body.userSettings,userId);
      if (response.status === 200 && response.data.result === "SUCCESS") {
          setUserSettings(body.userSettings);
          setLoaderRunning(false);
          ref.current.complete();
          setShowModal({ show: false });
          setTimeout(()=>{
            setShowModal({ show: true, type: MODAL_TYPE.THEME_PREFERENCE });
           },500)
      }else{
        setLoaderRunning(false);
        ref.current.complete();
      }
    }catch(e){
      setLoaderRunning(false);
      ref.current.complete();
    }
  }

  let PrimaryButtonList = [
    {
      title: "Start Tour",
      onclick: () => {
        setShowTour(true);
      },
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading="🌟 Welcome to the Enhanced Platform Experience!"
        handleCancel={() => handleCloseModal()}
      />
    ),
    body: <TourGuideBody setShowTour={setShowTour} />,
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={[]}
      />
    ),
    width: "800px",
  };

  const tourConfig = () => {
    let items = [
      {
        selector: '[data-tut="tour-category"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <strong>🚀 Explore our sleek new side navigation bar!</strong>
              <br />
              <span>
                Hover over any item to reveal a helpful tooltip explaining its
                purpose.
              </span>
              <br />
              <span>
                Want to see more options? Click the top-left arrow to expand the
                navigation bar and uncover a world of possibilities! 🌐
              </span>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-header"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <strong>🌟 Welcome to the User Hub!</strong>
              <br />
              <span>
                Take charge of your account and settings, and seamlessly logout
                or switch themes with ease.
              </span>
              <br />
              <span>
                Discover the 'Available Now' feature for quick access to support
                personnel contact details. Enjoy effortless control and
                convenience! 💻🚀
              </span>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-filter-section"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <strong>🔍 Welcome to the Studylist Filter Section!</strong>
              <br />
              <span>
                🌟 Easily refine your studylist by criteria. Simply type a
                patient name or ID in the patient search field, hit enter, or
                click 'Search icon'
              </span>
              <br />
              <span>
                🎯 For advanced filtering options, click the button '+ Filters'
                to explore various search options.
              </span>
              <br />
              <span>🚀 Simplify your search experience!</span>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-filter-popup"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <strong>Explore our various filters 🎨.</strong>
              <br />
              <span>
                Simply select or check the required filters, and when you're
                ready, click the 'Apply' button at the bottom right to make your
                filters work their magic! ✨🚀
              </span>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-tab-section"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>📑 Welcome to the Tab Section!</strong>
              </p>
              <br />
              <p>
                In this section, you'll find various tabs, including
                'Unreported,' 'Saved,' and 'Reported.'
              </p>
              <br />
              <p>
                Feel free to navigate through them to explore different sections
                based on your preferences and needs.
              </p>
              <br />
              <p>
                Enjoy the flexibility of choosing the tab that suits you the
                most! 🚀
              </p>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-patient-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <div>
                <p>
                  <strong>👤 Welcome to the Patient Details!</strong>
                </p>
                <p>Here's a friendly snapshot:</p>
                <ul>
                  <li>[Patient Name]</li>
                  <li>[Patient ID]</li>
                  <li>
                    [Gender] <strong>|</strong> [Age]
                  </li>
                </ul>
                <p>
                  Explore and navigate through the patient's key information
                  effortlessly! 🌟
                </p>
              </div>
            </span>
          </div>
        ),
      },
      {
        selector: '[data-tut="tour-study-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>📚 Welcome to the Study Details Section!</strong>
              </p>
              <ul>
                <li>[Study Description]</li>
                <li>[Study Date]</li>
                <li>Icons:</li>
                <ul>
                  <li>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "15px",
                        }}
                      >
                        <ChatIcon  
                          color={theme.palette.inactiveTool}
                        />
                      </span>{" "}
                      <span>&nbsp; Communication</span>
                    </span>
                  </li>
                  <li>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "15px",
                        }}
                      >
                        <ImageCount />
                      </span>
                      <span>&nbsp; Total Images [Images Count]</span>
                    </span>
                  </li>
                  <li>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "17px",
                        }}
                      >
                        {roles[0] != USERTYPES.RADIOLOGIST ? <UploadHistoryIcon />
                        : 
                                    <Icon
                      style={{color:getThemeColor("icon-color")}}
                      iconName={"FilePDB"}></Icon>
      }
                      </span>
                      <span>&nbsp; {roles[0] != USERTYPES.RADIOLOGIST?"Upload/":""}View History</span>
                    </span>
                  </li>
                  <li>
                    &nbsp;Colorful Badges for Different Modality Types</li>
                </ul>
              </ul>
              <p>
                Explore the study details effortlessly and stay informed! 🌟
              </p>
            </span>
          </div>
        ),
      },
    ];

    if (roles[0] === USERTYPES.ADMIN) {
      items.push({
        selector: '[data-tut="tour-client-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>Welcome to the Firm Details Section! 💼</strong>
              </p>
              <br />
              <p>
                In this section, you'll notice a distinguished circle badge with
                the letter 'F,' symbolizing 'Firm'
              </p>
              <br />
              <p>
                The firm's name is gracefully presented. It's worth noting that
                the circle badge is not clickable—no need to mistake it for a
                button! 😄
              </p>
              <br />
              <p>
                <strong>Pro Tip:</strong> There is a tooltip on hover.
              </p>
            </span>
          </div>
        ),
      });
      items.push({
        selector: '[data-tut="tour-provider-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>👥 Welcome to the Provider Details Section!</strong>
              </p>
              <br />
              <p>
                In this section, you'll find key information about the provider.
                The first line displays the provider's name, followed by the
                radiologist's name if already assigned.
              </p>
              <br />
              <p>
                Keep an eye out for a 'More Options' menu (three dots) nearby;
                it indicates additional layers of assignment within the chain.
                Explore the details effortlessly! 🌐
              </p>
            </span>
          </div>
        ),
      });
    }

    if (roles[0] === USERTYPES.FIRMADMIN) {
      items.push({
        selector: '[data-tut="tour-client-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>💼 Welcome to the Client Details Section!</strong>
              </p>
              <br />
              <p>
                Here, you'll find a distinctive circle badge with the letter 'C'
                signifying 'Client.' If there's a client, you'll see the name;
                otherwise, it'll display '-'. Keep in mind, the circle badge is
                not clickable—no need to mistake it for a button! 😄
              </p>
              <br />
              <p>
                <strong>Pro Tip:</strong> There is a tooltip on hover.
              </p>
            </span>
          </div>
        ),
      });
      items.push({
        selector: '[data-tut="tour-provider-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>👩‍⚕️ Welcome to the Provider Details Section!</strong>
              </p>
              <br />
              <p>
                Here, the circle badge could have the text 'R' for 'Radiologist'
                if the study is assigned to a radiologist, or 'P' if it is
                assigned to any provider. The name is displayed accordingly.
              </p>
              <br />
              <p>
                If there's no provider/radiologist assigned, or it's unassigned,
                you can select one from the dropdown. Make sure to click
                'Assign' button to complete the process.
              </p>
              <br />
              <p>
                <strong>NOTE:</strong> If you see a 'Reassign' button, you can
                assign the study to another radiologist/provider by clicking it.
                The 'Reassign' button is not just for removing the current
                assignment.
              </p>
              <br />
              <p>
                To unassign, look for the 'Red Lock' icon at the start of
                the studylist row (visibility is based on conditions). 🤔💡
              </p>
            </span>
          </div>
        ),
      });
    }

    if (roles[0] === USERTYPES.RADIOLOGIST) {
      items.push({
        selector: '[data-tut="tour-provider-details"]',
        content: () => (
          <div>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                color: "black",
              }}
            >
              <p>
                <strong>
                  👩‍⚕️💼 Welcome to the Radiologist/Firm Details Section!
                </strong>
              </p>
              <br />
              <p>
                Here, the circle badge could have the text 'R' for 'Radiologist'
                or 'P' for 'Provider.' The name is displayed accordingly. If
                there's no radiologist or provider assigned, you'll see '-'.
              </p>
              <br />
              <p>
                In the next line, 'F' stands for 'Firm,' and the name is next to
                it. If not present, you'll see '-'. Keep in mind, the circle
                badge is not clickable—no need to mistake it for a button! 😄
              </p>
            </span>
          </div>
        ),
      });
    }

    items.push({
      selector: '[data-tut="tour-report-details"]',
      content: () => (
        <div>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              color: "black",
            }}
          >
            <p>
              <strong>📋 Welcome to the Report Details Section!</strong>
            </p>
            <br />
            <p>
              In this section, you'll find informative badges indicating the
              study's platform presence, with colors reflecting its status, such
              as 'Less than 1 hr,' 'QC Verify,' 'QC Pending,' 'More than 3 hr,'
              and more. Each badge has a tooltip offering insights.
            </p>
            <br />
            <p>
              Additionally, check the assignment date. Pro tip: hover over
              badges for details!
            </p>
            <br />
            <p>
              On the right side, you may spot icons like 'Report,' 'Preview,'
              'Download'. Conditions apply for their visibility—stay tuned for
              those surprises! 🌟
            </p>
          </span>
        </div>
      ),
    });

    items.push({
      selector: '[data-tut="tour-action-details"]',
      content: () => (
        <div>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              color: "black",
            }}
          >
            <p>
              <strong>⚙️ Welcome to the Action Details Section!</strong>
            </p>
            <br />
            <p>
              Hover or click to unveil a menu with tailored actions based on
              your role and the study's state.
            </p>
            <br />
            <p>
              Explore options such as editing patient details, deleting the
              study, checking the TAT timeline, and more. Your actions, your
              control! 🌐
            </p>
          </span>
        </div>
      ),
    });

    items.push({
      selector: '[data-tut="tour-triage-details"]',
      content: () => (
        <div>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              color: "black",
            }}
          >
            <p>
              <strong>🚨 Welcome to the Alert Details Section!</strong>
            </p>
            <br />
            <p>
              This area not only showcases the alert state but also
              distinguishes between normal studies and critical ones.
            </p>
            <br />
            <p>
              It provides an in-depth list of findings detected by our AI. Each
              finding comes with its name and percentage, or if AI processing is
              in progress. 💡🔍
            </p>
          </span>
        </div>
      ),
    });

    items.push({
      selector: '[data-tut="end"]',
      content: () => (
        <div>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              color: "black",
            }}
          >
            <p>
              <strong>🎉 Congratulations!</strong>
            </p>
            <br />
            <p>
              You've completed all the steps. Now, you're fully equipped to
              explore more. Best of luck, and enjoy your reporting journey.
            </p>
            <br />
            <strong>Thank you for joining us on this tour!</strong>
          </span>
        </div>
      ),
    });

    return items;
  };

  const handleNextTourStep = () => {
    if (desiredStep < tourConfig().length) {
      if (desiredStep == 0) {
        setEnableButtonTourPurpose(() => {
          const newItem = { ...enableButtonTourPurpose };
          newItem.showHeader = true;
          return newItem;
        });
      } else if (desiredStep == 2) {
        setEnableButtonTourPurpose(() => {
          const newItem = { ...enableButtonTourPurpose };
          newItem.showHeader = false;
          newItem.showFilterPopup = true;
          return newItem;
        });
      } else {
        setDesiredStep((prev) => prev + 1);
        setEnableButtonTourPurpose(() => {
          const newItem = { ...enableButtonTourPurpose };
          newItem.showHeader = false;
          newItem.showFilterPopup = false;
          return newItem;
        });
      }
    }
  };

  const handlePrevTourStep = () => {
    if (desiredStep == 1) {
      setEnableButtonTourPurpose(() => {
        const newItem = { ...enableButtonTourPurpose };
        newItem.showHeader = false;
        newItem.showFilterPopup = false;
        return newItem;
      });
    } else if (desiredStep == 2) {
      setEnableButtonTourPurpose(() => {
        const newItem = { ...enableButtonTourPurpose };
        newItem.showHeader = true;
        newItem.showFilterPopup = false;
        return newItem;
      });
    } else if (desiredStep == 4) {
      setEnableButtonTourPurpose(() => {
        const newItem = { ...enableButtonTourPurpose };
        newItem.showHeader = false;
        newItem.showFilterPopup = true;
        return newItem;
      });
    } else if (desiredStep > 0) {
      setDesiredStep((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (enableButtonTourPurpose.showHeader) {
      setDesiredStep(1);
    } else if (desiredStep == 1) {
      setDesiredStep(0);
    }
    if (desiredStep > 0) {
      if (enableButtonTourPurpose.showFilterPopup) {
        setDesiredStep(3);
      } else if (desiredStep == 3) {
        setDesiredStep(2);
      }
    }
  }, [enableButtonTourPurpose]);

  return (
    <>
      {showTour ? (
        <Tour
          onRequestClose={() => {
            setEnableButtonTourPurpose(() => {
              const newItem = { ...enableButtonTourPurpose };
              newItem.showHeader = false;
              newItem.showFilterPopup = false;
              return newItem;
            });
            handleCloseModal();
            setShowModal({ show: false });
          }}
          steps={tourConfig()}
          isOpen={showModal.show}
          goToStep={desiredStep}
          accentColor="#5cb7b7"
          maskClassName="mask"
          showButtons={true}
          nextStep={() => handleNextTourStep()}
          prevStep={() => handlePrevTourStep()}
          className="helper"
          rounded={5}
        />
      ) : (
        <ModalMain
          updatedModal={true}
          modalDetails={modalDetails}
          showModal={true}
        />
      )}
    </>
  );
};

export default TourGuide;

const TourGuideBody = (props) => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px 45px",
          boxSizing: "border-box",
          alignItems: "center",
          color: getThemeColor("primary-color"),
          display: "flex",
          justifyItems: "center",
        }}
      >
        <p
          style={{
            width: "100%",
            textAlign: "justify",
            margin: "10px 0px",
            fontSize: "14px",
          }}
        >
          If you're new here, you're in for a treat! We've revamped the platform
          with exciting features and a sleek UI/UX. Ready to get comfortable? In
          case you want to <strong>skip</strong>, you can always begin the tour later by
          selecting <strong>'Tour'</strong> from the top-right header dropdown.
        </p>
        <p
          style={{
            width: "100%",
            textAlign: "justify",
            margin: "10px 0px",
            fontSize: "14px",
          }}
        >
          Press the <strong>'Start Tour'</strong> button to embark on a guided
          journey.
        </p>
        <p
          style={{
            fontStyle: "italic",
            fontSize: "14px",
            width: "100%",
            fontWeight: "bold",
          }}
        >
          **We strongly recommend going through the tour for a seamless
          transition to the enhanced platform. Happy exploring!
        </p>
        <br />
        <p>
          <strong style={{ fontStyle: "italic", fontSize: "14px" }}>
            During the tour, you can also use your keyboard's left ⬅️ and right
            ➡️ arrows for the next step. 😊✨
          </strong>
        </p>
      </div>
    </>
  );
};
